<template>
  <div style="position: relative">
    <div v-if="hidden.left" class="hidden left">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
      >
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path
          d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
        />
      </svg>
      <span>{{ hidden.left }}</span></div
    >
    <div v-if="hidden.right" class="hidden right">
      <span>{{ hidden.right }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
      >
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path
          d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
        />
      </svg>
    </div>
    <div class="card-box row">
      <div class="outer col-md-1" :class="aclass">
        <div class="inner rotate text-white">{{ title }}</div>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<script>
export const isInViewport = (element, body) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.left >= 0 &&
    rect.right <=
      (window.innerWidth + 40 || document.documentElement.clientWidth + 40)
  )
}

export const countOccurrencesUntilChange = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return {}
  }

  const result = {}
  let currentValue = arr[0]
  let currentCount = 0

  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === currentValue) {
      currentCount++
    } else {
      if (result[currentValue]) {
        result[currentValue].push(currentCount)
      } else {
        result[currentValue] = [currentCount]
      }

      currentValue = arr[i]
      currentCount = 1
    }
  }

  if (result[currentValue]) {
    result[currentValue].push(currentCount)
  } else {
    result[currentValue] = [currentCount]
  }

  return result
}

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['title', 'aclass'],
  data() {
    return {
      baggageShown: false,
      hidden: {
        left: false,
        right: false,
      },
    }
  },
  mounted() {
    this.initSlider()
  },
  methods: {
    initSlider() {
      const slider = this.$el.querySelector('.card-box.row')
      let isDown = false
      let startX = null
      let scrollLeft = null

      const xx = (slider) => {
        const cards = slider.querySelectorAll('.col-md-2')
        const vis = []
        const body = document.querySelector('.content-container')
        cards.forEach((card) => {
          vis.push(isInViewport(card, body))
        })

        const occurrences = countOccurrencesUntilChange(vis)
        if (false in occurrences) {
            console.log(slider.scrollLeft)
          this.hidden.left =
            occurrences.false && occurrences.false.length > 1
              ? occurrences.false[0]
              : slider.scrollLeft < window.innerWidth / 2
              ? 0
              : occurrences.false[0]
          this.hidden.right =
            occurrences.false && occurrences.false.length > 1
              ? occurrences.false[1]
              : slider.scrollLeft < window.innerWidth / 2
              ? occurrences.false[0]
              : 0
        } else {
          this.hidden.left = 0
          this.hidden.right = 0
        }
      }

      slider.addEventListener('mousedown', (e) => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 2
        slider.scrollLeft = scrollLeft - walk
        xx(slider)
      })

      xx(slider);
    },
  },
}
</script>

<style scoped>
.chat-module {
  justify-content: start;
}
.card-box.row {
  border-bottom: 1px solid #e7eaec;
  margin: 0 0rem;
  border-top: 1px solid #e7eaec;
  margin-bottom: -1px;
  align-items: flex-end;
  align-content: center;
}
.outer {
  height: 150px;
  max-width: 56px !important;
}
.cardarea-half {
}
.rotate {
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
}
.inner {
  font-size: 13px;
  font-color: #878787;
  position: absolute;
  top: 50%;
  left: 50%;
}
.layout-nav-side .content-container > .chat-module,
.layout-sidebar .content-container > .chat-module {
  overflow: hidden;
  padding: 0;
  align-content: flex-start;
}

.row {
  overflow: hidden;
  width: 100%;
  flex-wrap: nowrap;
}
.row.active {
  background: rgba(255, 255, 255, 0.3);
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1.015);
}
.hidden {
  height: 100%;
  position: absolute;
  background: #f8f9fa88;
  z-index: 999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 105px;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-weight: 600;
  font-size: 17px;
}
.hidden.right {
  right: 0;
}
.hidden span {
  background: #242835;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: white;
}
.hidden.left {
  background: linear-gradient(90deg, #f8f9fa 35%, transparent);
  width: 60px;
}
.hidden.right {
  background: linear-gradient(-90deg, #f8f9fa 35%, transparent);
}
</style>
